import { Component, OnInit } from '@angular/core';
import { MasterService,AttendanceService } from '../../services/index';
import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons, NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { AppGlobals } from '../../shared/app.global';

@Component({
  selector: 'app-attreport',
  templateUrl: './attreport.component.html',
  styleUrls: ['./attreport.component.scss'],
  providers:[MasterService,AttendanceService]
})
export class AttreportComponent implements OnInit {

  sections:any=[];
  classes:any=[];
  attcordata:any=[];
  arrsubjects:any=[];
  fmodel:any={clid:'0',secid:'0',subid:'0',prid:'0',atscope:'Individual'};
  attdata:any=[];
  attdata1:any=[];
  arrper:any=[];
  attcordetdata:any=[];
  arrcnmcls:any=[];
  arrcourse:any=[];
  oprtype:any='';
  tabledata: any = {};
  objclass:any={};
  arrstulst:any=[];
  fmodel1:any={};
  cmodel:any={};
  objvhead:any={};
  arrcmbdet:any=[];
  msgexist="";
  corclasses:any=[];
  corsections:any=[];
  corsubjects:any=[];
  modalOptions:NgbModalOptions;
  private modalRef: NgbModalRef;
  arratscope:any=[{name:'Individual'},{name:'Combined'}];
  arropt:any=[{name:'Yes'},{name:'No'}];

  dropdownList = [];
  selectedItems = [];
  colums:any=[];
  colums1:any=[];
  dropdownSettings:IDropdownSettings = {singleSelection: false,
    idField: 'stuid',
    textField: 'stunm',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 0,
    allowSearchFilter: true};
  constructor(private http: HttpClient,private aservice:AttendanceService, private mservice: MasterService,private modalService: NgbModal,private _global: AppGlobals) { }

  ngOnInit(): void {
    
    
    
    this.cmodel.oprtype='consolid';
    this.onclickcorrection();
   
  }

  addstudents()
  {

    console.log(this.selectedItems);
  }


  corclass() {
    this.mservice.classmasterrolewise(0,this.cmodel.crid,0,'class')
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
           // resultArray.unshift({clid:"0",clnm:"ALL",clcd:"ALL"});
            this.corclasses = resultArray;
            
            this.cmodel.clid=resultArray[0].clid;
            this.corsection();
           // this.masperiod();
           // this.mascourse();
           
        },
        error => console.log("Error :: " + error)
        )
  }


  
  

  corsection() {
    this.mservice.sectionsrolewise(0,this.cmodel.crid,this.cmodel.clid,'section')
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            //resultArray.unshift({scid:"0",scnm:"ALL",sccd:"ALL"});
            this.corsections = resultArray;
            
            this.cmodel.scid=resultArray[0].scid;
            this.corsubject();
            //this.subjects();
            this.subjects(this.cmodel.clid,this.cmodel.crid);
        },
        error => console.log("Error :: " + error)
        )
  }

  mascourse() {
      this.mservice.mascourse()
          .subscribe(
          resultArray => {
              console.log('getdashcounts', resultArray);
             // resultArray.unshift({crid:"0",crnm:"ALL",crcd:"ALL"});
              this.arrcourse = resultArray;
              this.fmodel.crid=resultArray[0].crid;
              this.fmodel1.crid=resultArray[0].crid;
              this.cmodel.crid=resultArray[0].crid;
            
              this.corclass();
          },
          error => console.log("Error :: " + error)
          )
    }

 
    corsubject() {
      this.mservice.staffrolewise()
          .subscribe(
          resultArray => {
              console.log('getdashcounts', resultArray);
              //resultArray.unshift({emid:"0",emnm:"ALL"});
              this.corsubjects = resultArray;
             
              this.cmodel.emid=resultArray[0].emid;
              this.SelectAttdcorDetails();
          },
          error => console.log("Error :: " + error)
          )
    }


    subjects(clid,crid) {
      this.mservice.subjectsrolewise(0,0,clid,'asaa',crid)
          .subscribe(
          resultArray => {
              console.log('getdashcounts', resultArray);
              this.arrsubjects = resultArray;
              //this.corsubjects = resultArray;
              this.cmodel.suid=resultArray[0].suid;
              this.attsubsum1();
             // this.cmodel.suid=resultArray[0].suid;
             // this.SelectAttdDetails();
          },
          error => console.log("Error :: " + error)
          )
    }
    
onconsolid()
{
  this.cmodel.oprtype='consolid';
  this.SelectAttdcorDetails();
}

exportcolrpt()
{
  var clcd=localStorage.getItem('clcd');
  var aycd=localStorage.getItem('aycd');
   var url=this.aservice.callurl+"export/expstftimesheet.php?clcd="+clcd+"&aycd="+aycd+"&dtfrm="+this.cmodel.frdt+"&dtto="+this.cmodel.todt+"&clid="+this.cmodel.clid+"&scid="+this.cmodel.scid+"&crid="+this.cmodel.crid+"&chtype="+this.cmodel.oprtype+"&emid="+this.cmodel.emid;
   console.log("url",url)
   window.open(url,'');

}

exptopdf()
{
  var clcd=localStorage.getItem('clcd');
  var aycd=localStorage.getItem('aycd');
  if(this.cmodel.oprtype=="detail")
  {
   var url=this.aservice.callurl+"pdf2/staftimesheet.php?clcd="+clcd+"&aycd="+aycd+"&dtfrm="+this.cmodel.frdt+"&dtto="+this.cmodel.todt+"&clid="+this.cmodel.clid+"&scid="+this.cmodel.scid+"&crid="+this.cmodel.crid+"&chtype="+this.cmodel.oprtype+"&emid="+this.cmodel.emid;
  }
  else if(this.cmodel.oprtype=="consolid")
  {
    var url=this.aservice.callurl+"pdf2/staftimesheet_cons.php?clcd="+clcd+"&aycd="+aycd+"&dtfrm="+this.cmodel.frdt+"&dtto="+this.cmodel.todt+"&clid="+this.cmodel.clid+"&scid="+this.cmodel.scid+"&crid="+this.cmodel.crid+"&chtype="+this.cmodel.oprtype+"&emid="+this.cmodel.emid;
  }
   console.log("url",url)
   window.open(url,'');

}


exportatsumsubrpt(suid)
{
  var clcd=localStorage.getItem('clcd');
  var aycd=localStorage.getItem('aycd');
   var url=this.aservice.callurl+"export/expatsumsub.php?clcd="+clcd+"&aycd="+aycd+"&dtfrm="+this.cmodel.frdt+"&dtto="+this.cmodel.todt+"&clid="+this.cmodel.clid+"&scid="+this.cmodel.scid+"&crid="+this.cmodel.crid+"&suid="+suid;
   console.log("url",url)
   window.open(url,'');

}
    
ondetail()
{
  this.cmodel.oprtype='detail';
  this.SelectAttdcorDetails();
}
    
    SelectAttdcorDetails() {
      debugger

      console.log('pstdat1',this.cmodel);

      this.aservice.getstafftimesheet(this.cmodel)
      .subscribe(resultArray => {
          console.log('ret-by-atd', resultArray);
          this.attcordata = resultArray;

          //alert(resultArray.message);

      }, error =>
          alert('error in connection')
      );
    }

    attsubsum() {
      //this.cmodel.oprtype='sum_subwise';
      console.log('pstdat',this.cmodel);
      this.cmodel.suid='0';

      this.aservice.attsumsub1(this.cmodel)
      .subscribe(resultArray => {
          console.log('ret-by-atd', resultArray);
          this.attdata = resultArray;
this.colums=Object.keys(resultArray[0]);
          //alert(resultArray.message);

      }, error =>
          alert('error in connection')
      );
    }

    attsubsum1() {
      //this.cmodel.oprtype='sum_subwise';
      console.log('pstdat',this.cmodel);

      this.aservice.attsumsub1(this.cmodel)
      .subscribe(resultArray => {
          console.log('ret-by-atd', resultArray);
          this.attdata1 = resultArray;
this.colums1=Object.keys(resultArray[0]);
          //alert(resultArray.message);

      }, error =>
          alert('error in connection')
      );
    }

    getattdetails() {

      console.log('pstdat',this.objvhead);

      this.aservice.getattdet(this.objvhead)
      .subscribe(resultArray => {
          console.log('ret-by-atd', resultArray);
          this.attcordetdata = resultArray;

          //alert(resultArray.message);

      }, error =>
          alert('error in connection')
      );
    }

    openmdldetmain(content,objdata) {
      debugger
        this.objvhead=objdata;
      
        this.getattdetails();
        this.modalOptions = {
          backdrop:'static',
          backdropClass:'customBackdrop',
          size:'lg'
         
        }
        this.modalRef=this.modalService.open(content,this.modalOptions);
        
        this.modalRef.result.then((result) => {
       
             
          }, (reason) => {
              
          });
      }
      

onclickcorrection()
{
  this.cmodel.oprtype='consolid';
  this.cmodel.frdt=this.mservice.getdatetoday();
  this.cmodel.todt=this.mservice.getdatetoday();
  this.mascourse();
}


}
